<template lang="pug">
  include ./../../../mixins
  div
    router-module()
    +b.pa--t_md.--b_md.SECTION
      +b.ug-container--variant_large
        +b.TEXT-BEMTO(
          :fw="'bold'"
          :lh="'small'"
          :fs="'xl'"
          :color="'black'"
          :tag="'p'"
        ) ORDER STATISTICS
        +b.ug-row--apearance_spaced.--space_md
          +b.ug-cell.ug-cols--12
            +b.pa--f_1sm.--f_md-md.bg--white.ma--t_md
              validation-observer(
                ref="observer"
                tag="form"
                class="form"
              )
                +b.ug-row--apearance_spaced.--space_md.--justify_between.--align_end
                  +b.ug-cell.ug-cols--12.--6-md.--3-lg
                    +b.D-CONTROL-OPTION(
                      v-model="formData.manufacturer"
                      :object-list="manufacturerItems"
                      :input-label="'Manufacturer'"
                      :placeholder="'Manufacturer'"
                      :name="'manufacturer'"
                      id="manufacturer"
                      @change="getModelsAPI"
                    )
                  +b.ug-cell.ug-cols--12.--6-md.--3-lg
                    +b.D-CONTROL-OPTION(
                      v-model="formData.model"
                      :object-list="modelItems"
                      :input-label="'Model'"
                      :placeholder="'Model'"
                      :name="'modelItems'"
                      id="modelItems"
                    )
                  +b.ug-cell.ug-cols--12.--6-md.--3-lg
                    +b.control-cabinet.--centered
                      +e.label Year Period
                    +b.ug-row--apearance_spaced.--space_sm.--align_end
                      +b.ug-cell.ug-cols--12.--auto-md
                        +b.input.D-CONTROL-INPUT(
                          v-model="carYear.dateGte"
                          :placeholder="'YYYY'"
                          :name="'dateGte'"
                          :type="'text'"
                          id="dateGte"
                          v-mask="'####'"
                        )
                      +b.ug-cell.ug-cols--12.--narrow-md.ma--off
                        +b.TEXT-BEMTO(
                          :cfg="'datetime'"
                          :fw="'bold'"
                          :lh="'small'"
                          :fs="'1xs'"
                          :color="'black'"
                          :tag="'p'"
                        ) to
                      +b.ug-cell.ug-cols--12.--auto-md
                        +b.input.D-CONTROL-INPUT(
                          v-model="carYear.dateLte"
                          :placeholder="'YYYY'"
                          :name="'dateLte'"
                          :type="'text'"
                          id="dateLte"
                          v-mask="'####'"
                        )
                  +b.ug-cell.ug-cols--12.--6-md.--3-lg
                    +b.D-CONTROL-OPTION(
                      v-model="formData.service"
                      :object-list="servicesItems"
                      :input-label="'Service'"
                      :placeholder="'Service'"
                      :name="'servicesItems'"
                      id="servicesItems"
                    )
                  +b.ug-cell.ug-cols--12.--6-lg
                    +b.control-cabinet.--centered
                      +e.label Date of booking
                    +b.ug-row--apearance_spaced.--space_sm.--align_end
                      +b.ug-cell.ug-cols--12.--auto-md
                        +b.control-cabinet.--centered
                          +e.element--centered.FLAT-PICKER(
                            v-model='createdAt.dateGte', :config="cfgDate",
                            placeholder='DD/MM/YYYY',
                            type="date",
                          )
                          +e.flat-toggle(
                            title="toggle"
                            data-toggle
                          )
                            +b.icon--type_date.I
                      +b.ug-cell.ug-cols--12.--narrow-md.ma--off
                        +b.TEXT-BEMTO(
                          :cfg="'datetime'"
                          :fw="'bold'"
                          :lh="'small'"
                          :fs="'1xs'"
                          :color="'black'"
                          :tag="'p'"
                        ) to
                      +b.ug-cell.ug-cols--12.--auto-md
                        +b.control-cabinet.--centered
                          +e.element--centered.FLAT-PICKER(
                            v-model='createdAt.dateLte', :config="cfgDate",
                            placeholder='DD/MM/YYYY',
                            type="date",
                          )
                          +e.flat-toggle(
                            title="toggle"
                            data-toggle
                          )
                            +b.icon--type_date.I
                  +b.ug-cell.ug-cols--12.--6-lg
                    +b.ug-row--apearance_spaced.--space_sm.--space_md-mac
                      +b.ug-cell.ug-cols--12.--6-sm.--7-xl
                        +b.button--height_xl.BUTTON-BEMTO(
                          :disabled="isRequest"
                          @event="resetPaginationBeforeAPI"
                        )
                          +e.load.IMG(
                            src="/static/load.gif"
                            v-if="isRequest"
                          )
                          +e.text(
                            v-if="!isRequest"
                          ) SEARCH
                      +b.ug-cell.ug-cols--12.--6-sm.--5-xl
                        +b.button--height_xl.--save.BUTTON-BEMTO(
                          :disabled="isRequest"
                          @event="clearOrderStatsFiltersHandler"
                        )
                          +e.load.IMG(
                            src="/static/load.gif"
                            v-if="isRequest"
                          )
                          +e.text(
                            v-if="!isRequest"
                          ) CLEAR
            +b.pa--r_1sm.--r_md-md.--l_1sm.--l_md-md.--b_1sm.bg--white
              order-statistics-table(
                v-if="Object.keys(orderStatisticsItem).length"
                :object-list="orderStatisticsItem"
                @ordering="setOrderingHandler"
              )
              +b.text.pa--b_xs-md(
                v-if="!Object.keys(orderStatisticsItem).length"
              ) No results
          +b.ug-cell.ug-cols--12
            +b.PAGINATION-MODULE(
              :pagination="pagination"
              :extra="1"
              :need-add-btns="true"
              @update-limit="setPaginationLimitHandler($event)"
              @input="pageСhangedHandler($event)"
            )
</template>

<script>
import {
  getOrderStatisticsAPI,
  getManufacturerAPI,
  getModelsAPI,
  getServicesAPI,
} from '@/js/services/cabinet'

import {
  asyncForEach,
} from '@/js/scripts/helpers'

import {
  mask
} from 'vue-the-mask'

export default {
  name: 'StatisticsCoreCabinet',
  directives: {
    mask,
  },
  async created() {
    await this.getOrderStatisticsAPI()
    await this.getManufacturerAPI()
    await this.getServicesAPI()
  },
  data() {
    return {
      /** */
      cfgDate: {
        dateFormat: 'd/m/Y',
        allowInput: true,
        wrap: true,
      },
      /** */
      orderStatisticsItem: {},
      pagination: {},
      paginationData: {},
      /** */
      manufacturerItems: [],
      modelItems: [],
      servicesItems: [],
      /** */
      formData: {
        manufacturer: null,
        model: null,
        service: null,
        ordering: null,
      },
      /** */
      createdAt: {
        dateGte: '',
        dateLte: '',
      },
      carYear: {
        dateGte: '',
        dateLte: '',
      },
      /** */
      isRequest: false,
    }
  },
  methods: {
    /**
     * Our request with get parameters, not to
     * be confused with CNC, here we need
     * special processing of the server
     * response.
     * @params {Object} OPTIONS
     */
    getOrderStatisticsAPI(OPTIONS) {
      return getOrderStatisticsAPI.execute(OPTIONS)
        .then(response => response.json())
        .then(response => {
          this.orderStatisticsItem = response.data.items
          this.pagination = response.data.pagination
        })
    },
    getModelsAPI() {
      this.modelItems = []
      this.formData.model = null
      return getModelsAPI.execute(
        { manufacturer: this.formData.manufacturer }
      )
        .then(response => {
          this.modelItems = response.data.items
        })
    },
    getManufacturerAPI() {
      return getManufacturerAPI.execute({})
        .then(response => {
          this.manufacturerItems = response.data.items
        })
    },
    getServicesAPI() {
      return getServicesAPI.execute({})
        .then(response => {
          this.servicesItems = response
        })
    },
    /**
     * Let's pre-format our form state.
     */
    async preperedBeforeAPI() {
      /**
       * Create the correct format for sending the date
       * and time to the server.
       */
      const DATETIME = {
        'created_at__gte': `${this.createdAt.dateGte}`,
        'created_at__lte': `${this.createdAt.dateLte}`,
      }
      const CARYEAR = {
        'car_year__gte': `${this.carYear.dateGte}`,
        'car_year__lte': `${this.carYear.dateLte}`,
      }
      /**
       * The task is not to send only the time to the server,
       * the date is also required, so we will delete
       * the keys in which there is no date, so as not
       * to send them.
       */
      await asyncForEach(
        Object.keys(DATETIME), async key => {
          /**
           * The some () method checks if any element of
           * the array satisfies the condition specified
           * in the passed function.
           */
          if (DATETIME[key].length <= this.inits) {
            delete DATETIME[key]
          }
        }
      )
      /**
       * The task is not to send only the time to the server,
       * the date is also required, so we will delete
       * the keys in which there is no date, so as not
       * to send them.
       */
      await asyncForEach(
        Object.keys(CARYEAR), async key => {
          /**
           * The some () method checks if any element of
           * the array satisfies the condition specified
           * in the passed function.
           */
          if (CARYEAR[key].length <= this.inits) {
            delete CARYEAR[key]
          }
        }
      )
      /**
       * We merge all the data thatwe have in thefilters and
       * finish the preliminarykey formatting.
       */
      const OPTIONS = {
        ...this.formData,
        ...this.paginationData,
        ...DATETIME,
        ...CARYEAR,
      }
      /**
       * We will wait until everything is filled correctly.
       */
      await asyncForEach(
        Object.keys(OPTIONS), async key => {
          /**
           * The some () method checks if any element of
           * the array satisfies the condition specified
           * in the passed function.
           */
          if (!OPTIONS[key]) {
            delete OPTIONS[key]
          }
        }
      )
      /**
       * Pay attention to the description of this method.
       */
      await this.getOrderStatisticsAPI(
        OPTIONS
      )
    },
    async clearOrderStatsFiltersHandler() {
      await asyncForEach(
        Object.keys(this.formData), async key => {
          this.formData[key] = null
        }
      )
      await asyncForEach(
        Object.keys(this.createdAt), async key => {
          this.createdAt[key] = ''
        }
      )
      this.paginationData.offset = 0
      await this.preperedBeforeAPI()
    },
    async resetPaginationBeforeAPI() {
      this.paginationData.offset = 0
      await this.preperedBeforeAPI()
    },
    async setPaginationLimitHandler(value) {
      this.paginationData.limit = value
      this.paginationData.offset = 0
      await this.preperedBeforeAPI()
    },
    async pageСhangedHandler(data) {
      this.paginationData = data
      await this.preperedBeforeAPI()
    },
    async setOrderingHandler(value) {
      this.formData.ordering = value
      await this.preperedBeforeAPI()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Pages/Cabinet/StatisticsCoreCabinet.vue